/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ViewRequirementConditionFromJSON, ViewRequirementConditionToJSON } from './ViewRequirementCondition';

/**
 * 
 * @export
 * @interface ViewRequirement
 */

/**
* @export
* @enum {string}
*/
export var ViewRequirementEffectEnum = /*#__PURE__*/function (ViewRequirementEffectEnum) {
  ViewRequirementEffectEnum["Allow"] = "allow";
  ViewRequirementEffectEnum["Deny"] = "deny";
  return ViewRequirementEffectEnum;
}({});

/**
 * Check if a given object implements the ViewRequirement interface.
 */
export function instanceOfViewRequirement(value) {
  if (!('condition' in value) || value['condition'] === undefined) return false;
  return true;
}
export function ViewRequirementFromJSON(json) {
  return ViewRequirementFromJSONTyped(json, false);
}
export function ViewRequirementFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'effect': json['effect'] == null ? undefined : json['effect'],
    'condition': ViewRequirementConditionFromJSON(json['condition'])
  };
}
export function ViewRequirementToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'effect': value['effect'],
    'condition': ViewRequirementConditionToJSON(value['condition'])
  };
}